/* LoudBox Fireworks: 8-bit fireworks over a pixel skyline (header + homepage banner). Only runs when body has .lb-fireworks */
(function(){
  var COLS = ['#f7b928','#ffe39a','#ff5cb8','#3dff8a','#8fb4ff','#e45cff','#ffffff','#ff7a1a'];
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function mount(host, o){
    o = o || {};
    var cols = o.cols || COLS, sc = o.starCols || ['#ffe39a','#8fb4ff','#555555'];
    var wrap = document.createElement('div'); wrap.className = o.cls || 'lb-fw'; wrap.setAttribute('aria-hidden','true');
    var c = document.createElement('canvas'); wrap.appendChild(c);
    host.insertBefore(wrap, host.firstChild);
    var x = c.getContext('2d'), P = 4, W = 0, H = 0, city = [], stars = [], rockets = [], sparks = [], t = 0, last = 0, next = 0, inView = true;
    var cityH = o.cityH || [.12, .22], maxR = o.maxRockets || 3, gap = o.gap || [14, 34];
    function size(){
      var r = wrap.getBoundingClientRect(); if (!r.width || !r.height) return;
      P = innerWidth < 750 ? 3 : 4;
      var nw = Math.ceil(r.width / P), nh = Math.ceil(r.height / P);
      if (nw === W && nh === H) return;
      W = nw; H = nh; c.width = W; c.height = H; x.imageSmoothingEnabled = false;
      city = []; stars = []; var cx = 0, seed = o.seed || 7;
      function rnd(){ seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
      while (cx < W){
        var bw = 6 + Math.floor(rnd()*12), bh = Math.floor(H*(cityH[0] + rnd()*cityH[1]));
        var win = [];
        for (var wy = 3; wy < bh - 1; wy += 3) for (var wx = 2; wx < bw - 1; wx += 3) if (rnd() < .3) win.push([wx, wy, rnd() < .5 ? '#f7b928' : '#ffe39a']);
        city.push({x: cx, w: bw, h: bh, win: win, ant: rnd() < .15}); cx += bw + (rnd() < .3 ? 1 : 0);
      }
      if (o.stars) for (var s = 0; s < W*H/(o.starDiv || 700); s++) stars.push([Math.floor(rnd()*W), Math.floor(rnd()*H*(o.city === false ? 1 : .8)), rnd()]);
    }
    function launch(tx, ty){
      if (!W || o.rockets === false) return;
      var sx = tx != null ? tx : W*(.04 + Math.random()*.92);
      var ex = sx + (Math.random()-.5)*W*.06, ey = ty != null ? ty : H*(.12 + Math.random()*.4);
      rockets.push({x: sx, y: H - 2, vx: (ex - sx)/40, vy: -(H - ey)/40, ty: ey, col: cols[Math.floor(Math.random()*cols.length)], life: 40});
    }
    function burst(r){
      var n = 24 + Math.floor(Math.random()*20), ring = Math.random() < .4, c2 = cols[Math.floor(Math.random()*cols.length)];
      for (var i = 0; i < n; i++){
        var a = (i / n) * Math.PI * 2, s = ring ? .9 : .25 + Math.random()*.75;
        sparks.push({x: r.x, y: r.y, vx: Math.cos(a)*s, vy: Math.sin(a)*s, life: 40 + Math.random()*22, col: i % 3 ? r.col : c2});
      }
    }
    function px(a, y, col){ x.fillStyle = col; x.fillRect(Math.round(a), Math.round(y), 1, 1); }
    function drawStars(){
      for (var i = 0; i < stars.length; i++){
        var s = stars[i], per = 110 + Math.floor(s[2]*160), ph = (t + Math.floor(s[2]*997)) % per;
        if (s[2] > .5 || ph < 3) { if (s[2] <= .5) continue; } // most stars stay steady; some blink off briefly
        var c = s[2] < .12 ? sc[0] : s[2] < .25 ? sc[1] : sc[2];
        px(s[0], s[1], c);
        if (s[2] < .025 && ph > per*.45 && ph < per*.55){ x.fillStyle = c; x.fillRect(s[0]-1, s[1], 3, 1); x.fillRect(s[0], s[1]-1, 1, 3); } // twinkle cross
      }
    }
    function drawCity(){
      for (var i = 0; i < city.length; i++){
        var k = city[i], top = H - k.h;
        x.fillStyle = o.cityCol || '#07011c'; x.fillRect(k.x, top, k.w, k.h);
        x.fillStyle = o.roofCol || '#1d0a6b'; x.fillRect(k.x, top, k.w, 1);
        if (k.ant){ x.fillStyle = o.cityCol || '#07011c'; x.fillRect(k.x + (k.w>>1), top - 4, 1, 4); if ((t >> 5) % 2) px(k.x + (k.w>>1), top - 5, '#ff5cb8'); }
        for (var j = 0; j < k.win.length; j++){ var w = k.win[j]; x.fillStyle = w[2]; x.fillRect(k.x + w[0], top + w[1], 1, 1); }
      }
    }
    function draw(){
      x.clearRect(0, 0, W, H);
      if (o.stars) drawStars();
      if (o.rockets !== false && t >= next && rockets.length < maxR){ launch(); next = t + gap[0] + Math.floor(Math.random()*gap[1]); }
      for (var i = rockets.length - 1; i >= 0; i--){
        var r = rockets[i]; r.x += r.vx; r.y += r.vy; r.life--;
        px(r.x, r.y, '#ffffff'); px(r.x, r.y + 1, r.col); if (t % 2) px(r.x - r.vx, r.y + 2, '#b97a06');
        if (r.y <= r.ty || r.life <= 0){ burst(r); rockets.splice(i, 1); }
      }
      for (var s = sparks.length - 1; s >= 0; s--){
        var p = sparks[s]; p.x += p.vx; p.y += p.vy; p.vy += .014; p.vx *= .975; p.vy *= .975; p.life--;
        if (p.life <= 0){ sparks.splice(s, 1); continue; }
        if (p.life < 12 && (t + s) % 3 === 0) continue; // 8-bit twinkle as it fades
        var big = p.life > 36 ? 2 : 1; x.fillStyle = p.life < 16 ? '#b97a06' : p.col; x.fillRect(Math.round(p.x), Math.round(p.y), big, big);
      }
      if (o.city !== false) drawCity();
    }
    function frame(now){
      requestAnimationFrame(frame);
      if (document.hidden || !inView || now - last < 33) return; // ~30fps, chunky
      last = now; t++; draw();
    }
    function still(){ // reduced motion: one frozen frame
      x.clearRect(0, 0, W, H); if (o.stars) drawStars();
      if (o.rockets !== false) for (var k = 0; k < 4; k++){ burst({x: W*(.12 + k*.25), y: H*(.25 + (k%2)*.15), col: cols[(k*2)%cols.length]}); }
      for (var j = 0; j < 18; j++) sparks.forEach(function(p){ p.x += p.vx; p.y += p.vy; });
      sparks.forEach(function(p){ px(p.x, p.y, p.col); }); sparks = []; if (o.city !== false) drawCity();
    }
    size();
    if (window.ResizeObserver) new ResizeObserver(function(){ size(); if (reduce) still(); }).observe(wrap);
    else addEventListener('resize', function(){ size(); if (reduce) still(); });
    if (window.IntersectionObserver) new IntersectionObserver(function(e){ inView = e[0].isIntersecting; }).observe(wrap);
    if (reduce){ still(); } else { requestAnimationFrame(frame); }
    return { launch: function(n){ if (reduce) return; for (var q = 0; q < (n || 3); q++) launch(); }, at: function(cx, cy){ var r = wrap.getBoundingClientRect(); launch((cx - r.left) / P, (cy - r.top) / P); }, wrap: wrap };
  }
  function boot(){
    var b = document.body; if (!b || !b.classList.contains('lb-fireworks')) return;
    var host = document.querySelector('header.header') || document.querySelector('.header-wrapper');
    if (host){ var setHB = function(){ host.style.setProperty('--lbfw-hb', Math.max(0, parseFloat(getComputedStyle(host).paddingBottom) - 3) + 'px'); }; setHB(); if (window.ResizeObserver) new ResizeObserver(setHB).observe(host); }
    var head = host ? mount(host, {cols: ['#f7b928','#ffe39a','#fff3c4','#ffd25c','#ffffff','#e0a106'], stars: true, starCols: ['#ffe39a','#f7b928','#5a4a20'], cityCol: '#000', roofCol: '#5a4310'}) : null;
    var scenes = [].slice.call(document.querySelectorAll('[data-lb-fw-scene]')).map(function(el){
      return mount(el, {cls: 'lb-fw-scene', stars: true, rockets: false, city: false, starDiv: 160, starCols: ['#ffe39a','#f7b928','#8a8a8a'], cityH: [.04, .07], maxRockets: 5, gap: [8, 22], cityCol: '#000', roofCol: '#2b2b2b', seed: 11});
    });
    window.lbFireworks = function(n){ if (head) head.launch(n); scenes.forEach(function(s){ s.launch(n); }); };
    document.addEventListener('click', function(e){
      if (reduce || !e.target.closest) return;
      var sc = e.target.closest('[data-lb-fw-scene]');
      if (sc && !e.target.closest('a')){ for (var i = 0; i < scenes.length; i++) if (sc.contains(scenes[i].wrap)) { scenes[i].at(e.clientX, e.clientY); scenes[i].launch(2); } return; }
      if (head && (e.target === host || e.target === head.wrap)) head.at(e.clientX, e.clientY);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
